<template>
  <vz-sidebar ref="sidebar">
    <template #title>
      <div class="vz-personal-order-total-sidebar-title-price">
        <vz-loader
          :status-loader="orderStore.orderTotalPriceLoader"
          small-size
        />
        <div class="vz-personal-order-total-sidebar-title-price-wrapper">
          <vz-order-total-price-cost class="vz-personal-order-total-sidebar-title-price-cost"/>
          <vz-order-total-price-get-btn
            v-if="!orderStore.costDisabledReason"
            draft-as-button
            item-class="vz-order-sidebar-total-price-get-btn-item"
            @send-form="sendForm"
            @get-price="orderStore.getOrderPriceAction"
            @create-draft="orderStore.createDraft"
          />
        </div>
      </div>
    </template>
    <vz-order-individual-total
      :price-toggle="false"
      @send-form="sendForm"
    />
  </vz-sidebar>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import VzSidebar from '~/components/ui-kit/vz-sidebar.vue';
import VzOrderTotalPriceGetBtn from '~/components/personal/order/vz-order-total-price-get-btn.vue';
import VzOrderTotalPriceCost from '~/components/personal/order/vz-order-total-price-cost.vue';
import VzLoader from '~/components/ui-kit/vz-loader.vue';
import VzOrderIndividualTotal from '~/components/personal/order/individual/vz-order-individual-total.vue';

const emit = defineEmits(['send-form'])

const orderStore = useOrderStore()
const sidebar = ref()

function sendForm() {
  if (sidebar.value.visible) {
    sidebar.value.visible = false
  }
  emit('send-form')
}
</script>


<style lang="scss" scoped>

</style>

